import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import AddAddress from "../components/AddAddress";



const AddNewAddressPage = () => {
    const navigate = useNavigate();
    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            navigate('/unauthorize');
        }

    }, []);



    return (
        <React.Fragment >
            <AddAddress />
        </React.Fragment>
    );
};

export default AddNewAddressPage;